import { useState } from 'react';

import { Controller } from 'react-hook-form';
import { FormRow } from '@gravity-ui/components';

import { Button, Icon, Select, Sheet } from '@gravity-ui/uikit';

import { CHOOSE_SUBSECTION, SUBSECTION } from '../../../constants';
import { Xmark } from '@gravity-ui/icons';
import styles from './styles.module.scss';

export const SubsectionsSelect = ({
	control,
	index,
	subsectionsOptions,
	formValues,
	register,
	setValue,
	errors,
	isMobile,
}: any) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			{isMobile ? (
				<FormRow label={SUBSECTION} className={styles.row} required>
					<Controller
						control={control}
						name={`problems.${index}.subsection.sectionName`}
						render={({ field: { onChange, onBlur, ref, value }, fieldState: { error } }) => {
							return (
								<Select
									className={styles.row__select}
									size="xl"
									hasClear
									placeholder={CHOOSE_SUBSECTION}
									key={value || 'default-key'}
									value={value ? [value] : []}
									options={subsectionsOptions}
									onUpdate={(value) => {
										const selected = value[0] || null;
										setValue(`problems.${index}.subsection.sectionName`, selected);
									}}
									validationState={
										errors?.problems?.[index]?.subsection?.sectionName ? 'invalid' : undefined
									}
									errorPlacement="inside"
									errorMessage={errors?.problems?.[index]?.subsection?.sectionName}
									onBlur={onBlur}
									ref={ref}
									open={isOpen}
									onOpenChange={setIsOpen}
									renderPopup={({ renderList }) => (
										<Sheet
											visible={isOpen}
											onClose={() => setIsOpen(false)}
											title="Выберите подраздел"
											className={styles.sheet}
										>
											<div className={styles.sheet__close}>
												<Button onClick={() => setIsOpen(false)} view="flat">
													<Icon data={Xmark} size={16} />
												</Button>
											</div>

											{renderList?.()}
										</Sheet>
									)}
								/>
							);
						}}
					/>
				</FormRow>
			) : (
				<FormRow className={styles.row} label={SUBSECTION} required>
					<Select
						className={styles.row__select}
						size="xl"
						hasClear
						key={formValues.problems?.[index]?.subsection?.sectionName || 'default-key'}
						value={
							formValues.problems?.[index]?.subsection?.sectionName
								? [formValues.problems?.[index]?.subsection?.sectionName]
								: []
						}
						placeholder={CHOOSE_SUBSECTION}
						{...register(`problems.${index}.subsection.sectionName`, { required: true })}
						onUpdate={(value) => {
							const selected = value[0] || null;
							setValue(`problems.${index}.subsection.sectionName`, selected);
						}}
						validationState={errors?.problems?.[index]?.subsection?.sectionName ? 'invalid' : undefined}
						errorPlacement="inside"
						errorMessage={
							errors?.problems?.[index]?.subsection?.sectionName
								? 'Обязательно для заполнения'
								: undefined
						}
						options={subsectionsOptions}
					/>
				</FormRow>
			)}
		</>
	);
};
